import { DEFAULT_PAGING_SIZE } from "../../../../utilities/staticConfigs";
import { defaultSelectedColumnsList, filter_Options } from "../constants";

export const initialState={
    eraSearchVariables:{
        payment_date_from:"",
        searchPayer:[], 
        payment_date_to:"",
        era_uploaded_date_from:"",
        era_uploaded_date_to:"",
        payment_reference:"",
        payment_amount:"",
        show_type:"",
        payment_mode:"",
        payer:""
    },
    editEraVariables:{
        "payer_name": "", "eft": "", "check_date": "",
        "check_amount": "",
    },
    insurancePaymentVariables:{
        "era_payer": "", "era_payer_name": "", "payment_date": "", "paymentDate": "", "reference_check_number": "", "amount": "",
        "payment_mode": "", "card_type": null, "level_adjustments": 0, "adjustment_type": [], "note": ""
    },
    eraOriginalData:{},
    eraEditModalData:{},
    eraTableData:[],
    reviewedClaimList:[],
    reviewData: {},
    originalReviewData:{},
    claimDataForEraManualAdd:{custom_claim_id: '', patient_name: '', dos_from: '', dos_to: '', payer_types: '', responsible_payer: ''},
    procedureData:{},
    duplicateProcedureData:{},
    eraReviewModal:false,
    reviewKey:false,
    searchKey:false,
    notifyMessage: "",
    showNotification: false,
    statusTag: "",
    showAlertMessage:false,
    alertMessage:"",
    procedureError:{},
    lastOpenedClaimRowItem:'',
    header:"",
    saveWithOverRide:false,
    list:{
        eraPayerList:[],
        multiPayAdjType:[],
        payAdjTypeArr:[],
        paymentAdjustmentType:[],
        claimStatusList:[],
        claimSubStatusList:[],
        adjustment1:[],
        adjustment2:[],
        claimsListForModalDropdown:[]
    },
    selectedEraList:[],
    lastOpenedEraRowItem:"",
    selectAll:false,
    pageSelector:{
        pageLimit:DEFAULT_PAGING_SIZE,
        totalCount:""
    },
    pagination:{
        totalPage:"",
        activePage:"",
        startIndex:"",
        endIndex:"",
    },
    loader:false,
    clearFlag:0,
    calledFrom:'',
    isApplied:false,
    eraAppliedStatus:null,
    isReviewAll:false,
    selectedPaymentPK:"",
    paymentAdjustmentAmount:0.00,
    filterOption:{
        filterlabel:filter_Options[0].name,
        selectInputValue:filter_Options[0].id,
        searchTerm:"",
    },
    isAllProcedureApplied:false,
    deleteModal:{
        open:false,
        claim_pk:"",
        claim_id:"",
        element:""
    },
    xlsExportKey:{
    isFieldsChecked:false,
    selectedPK:"",
    selectedColumns:defaultSelectedColumnsList,
    columnModalOpen:false,
    columnHeader:"",
    },
    resposibility:[],
    originalResponsibility:[],
    addNewModal:false,
    isAsyncTypeSearching:false,
    showEditERAModal:false,
    eramodalEditFlag:false,
    isNewClaimAdded:false,
    isapplied_success:false,
    credit_confirmation_modal:false,
    current_procedure_id:"",
    openMuiDialogueForProcedure:false,
    isManuallyAddClaimCloseConfirm:false
}